var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _Client_instances, _Client_authManager, _Client_status, _Client_checkTokenInterval, _Client_callbacks, _Client_init, _Client_changeToken, _Client_getCallback, _Client_emit, _Client_checkToken;
import { AuthManager } from "./auth-manager";
import { TOKEN } from "./constants/token";
import { EClientStatus } from "./enums/EClientStatus";
import { EClientSubscription } from "./enums/EClientSubscription";
export class Client {
    constructor(options) {
        _Client_instances.add(this);
        _Client_authManager.set(this, void 0);
        _Client_status.set(this, void 0);
        _Client_checkTokenInterval.set(this, void 0);
        _Client_callbacks.set(this, new Map());
        __classPrivateFieldGet(this, _Client_instances, "m", _Client_init).call(this, options);
    }
    /**
     * widget 사용할 준비 상태로 만듬
     */
    async activate() {
        const status = await __classPrivateFieldGet(this, _Client_instances, "m", _Client_changeToken).call(this);
        if (status === EClientStatus.Active) {
            __classPrivateFieldGet(this, _Client_instances, "m", _Client_emit).call(this, EClientSubscription.Init, null);
        }
    }
    /**
     * token 업데이트
     */
    async setApiKey(options) {
        __classPrivateFieldGet(this, _Client_authManager, "f").setApiKey(options);
        await __classPrivateFieldGet(this, _Client_instances, "m", _Client_changeToken).call(this);
    }
    /**
     * token 꺼내기
     */
    async getToken() {
        const value = await __classPrivateFieldGet(this, _Client_authManager, "f").getAuthValue();
        if (value.type === "secret") {
            return value.token.raw;
        }
        else if (value.type === "no_token") {
            return undefined;
        }
        else if (value.type === "expired_token") {
            /**
             * @TODO 토큰 만기시
             */
            throw new Error("Expired token");
        }
        else {
            /**
             * @TODO 토큰 꺼낼시 에러처리
             */
            throw new Error(value.reason);
        }
    }
    /**
     * origin 꺼내기
     */
    getOrigin() {
        return __classPrivateFieldGet(this, _Client_authManager, "f").getOrigin();
    }
    on(type, callback) {
        const callbacks = __classPrivateFieldGet(this, _Client_instances, "m", _Client_getCallback).call(this, type);
        callbacks.add(callback);
        return () => {
            callbacks.delete(callback);
        };
    }
}
_Client_authManager = new WeakMap(), _Client_status = new WeakMap(), _Client_checkTokenInterval = new WeakMap(), _Client_callbacks = new WeakMap(), _Client_instances = new WeakSet(), _Client_init = function _Client_init(options) {
    __classPrivateFieldSet(this, _Client_authManager, new AuthManager({
        apiKey: options.apiKey,
        origin: options.origin,
    }), "f");
}, _Client_changeToken = async function _Client_changeToken() {
    const token = await __classPrivateFieldGet(this, _Client_authManager, "f").getAuthValue();
    if (token.type == "secret") {
        __classPrivateFieldSet(this, _Client_status, EClientStatus.Active, "f");
        __classPrivateFieldGet(this, _Client_instances, "m", _Client_checkToken).call(this);
    }
    else if (token.type === "expired_token") {
        __classPrivateFieldSet(this, _Client_status, EClientStatus.Disabled, "f");
    }
    else if (token.type === "error") {
        __classPrivateFieldSet(this, _Client_status, EClientStatus.Disabled, "f");
    }
    else if (token.type === "no_token") {
        __classPrivateFieldSet(this, _Client_status, EClientStatus.Disabled, "f");
    }
    else {
        throw new TypeError(`Unexpected token type ${token}`);
    }
    __classPrivateFieldGet(this, _Client_instances, "m", _Client_emit).call(this, EClientSubscription.ChangeStatus, __classPrivateFieldGet(this, _Client_status, "f"));
    return __classPrivateFieldGet(this, _Client_status, "f");
}, _Client_getCallback = function _Client_getCallback(type) {
    let callbackStore = __classPrivateFieldGet(this, _Client_callbacks, "f").get(type);
    if (callbackStore) {
        return callbackStore;
    }
    callbackStore = new Set();
    __classPrivateFieldGet(this, _Client_callbacks, "f").set(type, callbackStore);
    return callbackStore;
}, _Client_emit = function _Client_emit(type, params) {
    const callbacks = __classPrivateFieldGet(this, _Client_instances, "m", _Client_getCallback).call(this, type);
    callbacks.forEach((callback) => callback(params));
}, _Client_checkToken = function _Client_checkToken() {
    clearInterval(__classPrivateFieldGet(this, _Client_checkTokenInterval, "f"));
    __classPrivateFieldSet(this, _Client_checkTokenInterval, setInterval(async () => {
        /**
         * `getAuthValue`은 캐시 데이터에 있는 jwt 만료시간 확인하는 로직이라
         * 네트워크 요청이 발생하지 않음
         */
        const token = await __classPrivateFieldGet(this, _Client_authManager, "f").getAuthValue();
        if (token.type === "expired_token") {
            __classPrivateFieldGet(this, _Client_instances, "m", _Client_emit).call(this, EClientSubscription.ExpiredToken, null);
            __classPrivateFieldGet(this, _Client_instances, "m", _Client_emit).call(this, EClientSubscription.ChangeStatus, EClientStatus.Disabled);
            clearInterval(__classPrivateFieldGet(this, _Client_checkTokenInterval, "f"));
        }
    }, TOKEN.BUFFER / 2), "f");
};
//# sourceMappingURL=client.js.map